<div class="min-h-dvh d-flex align-items-center justify-content-center px-3 py-4">
    @if (store.failure(); as failure) {
        <div class="card shadow-sm w-100 max-w-md">
            <div class="card-body p-4 text-center" role="alert">
                <h1 class="h5 fw-bold mb-3">{{
                        {
                            feature: 'Web App',
                            component: 'Blue Launch',
                            label: 'Raptor could not be opened'
                        } | translate
                    }}</h1>
                <p id="launch-failure-message" class="text-body-secondary mb-0">
                    @switch (failure) {
                        @case (LaunchFailure.SessionInvalid) {
                            {{
                                {
                                    feature: 'Web App',
                                    component: 'Blue Launch',
                                    label: 'Your Marlin Blue session has ended. Sign in to Marlin Blue again, then reopen Raptor from the Workshop Dashboard.'
                                } | translate
                            }}
                        }
                        @case (LaunchFailure.NoBranch) {
                            {{
                                {
                                    feature: 'Web App',
                                    component: 'Blue Launch',
                                    label: 'Your Marlin Blue session is not signed in to a branch. Select a branch in Marlin Blue, then reopen Raptor from the Workshop Dashboard.'
                                } | translate
                            }}
                        }
                        @case (LaunchFailure.NotPermitted) {
                            {{
                                {
                                    feature: 'Web App',
                                    component: 'Blue Launch',
                                    label: 'This Marlin Blue account is not permitted to open Raptor. Contact your administrator if you need access.'
                                } | translate
                            }}
                        }
                        @case (LaunchFailure.Unavailable) {
                            {{
                                {
                                    feature: 'Web App',
                                    component: 'Blue Launch',
                                    label: 'Marlin Blue could not be reached. Please try again shortly.'
                                } | translate
                            }}
                        }
                        @default {
                            {{
                                {
                                    feature: 'Web App',
                                    component: 'Blue Launch',
                                    label: 'Raptor could not complete the sign-in from Marlin Blue. Please reopen Raptor from the Workshop Dashboard.'
                                } | translate
                            }}
                        }
                    }
                </p>
            </div>
        </div>
    } @else {
        <div class="text-center" role="status">
            <div class="spinner-border text-primary" aria-hidden="true"></div>
            <div class="mt-3 text-body-secondary">{{
                    {
                        feature: 'Web App',
                        component: 'Blue Launch',
                        label: 'Signing you in...'
                    } | translate
                }}
            </div>
        </div>
    }
</div>
